module.exports = __webpack_public_path__ + "static/media/br.8909bc2f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/br.svg
// module id = 874
// module chunks = 0